export default __webpack_public_path__ + "static/media/et-be.16ef35d1.svg";